interface StringConstructor {
  format(subject: string, ...replacements: string[]): string
}

String.format = (subject: string, ...args: string[]): string => {
  return subject.replace(/{(\d+)}/g, (match, index) => {
    return typeof args[index] !== 'undefined' ? args[index] : match
  })
}
